import { string } from '@/shared/libs/yup';
import { HookFormField, FieldInputProps } from '@/shared/libs/hook-form';

export const addressSchema = string().label('Address');

export const AddressField = (props: FieldInputProps) => <HookFormField.Input label="Address" {...props}/>;